<template lang="html">
  <div class="exam-result-component">

    <v-dialog
      v-model="alert_dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <v-icon
            color="red"
            x-large
          >warning_amber</v-icon>
          {{alert_title}}
        </v-card-title>

        <v-container v-html="alert_message"></v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="alert_dialog = false"
          >
            Bezár
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <h2 class="text-center">Vizsgaeredmények</h2>
      <br>
      <v-progress-linear
            v-if="ex_res_loading"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-row class="justify-center" v-if="contract_id">
        <v-col class="text-center" cols="12" md="3" v-if="!ex_res_loading && student_exam_result == ''">
          <v-btn
            color="primary"
            outlined
            rounded
            :disabled="!valid_course"
            @click="exam_app_dialog = true"
          >Vizsgára jelentkezés</v-btn>
          </v-col>
          <v-col cols="12" md="3" class="text-center" v-if="!ex_res_loading">
          <v-btn
            color="primary"
            outlined
            rounded
            :disabled="!valid_course"
            @click="getExamFees()"
          >Vizsgadíj befizetés</v-btn>
          </v-col>
      </v-row>
      <div v-if="!ex_res_loading && student_exam_result == ''">
      <br>
      <v-row justify="center">
          <h3>Elméleti vizsgára jelentkezés feltételei:</h3>
      </v-row>
      <br>
            <v-stepper non-linear>
              <v-stepper-header>
                <v-stepper-step
                  editable
                  step="1"
                >
                  Tanfolyam befejezése
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                  editable
                  step="2"
                >
                  Orvosi alkalmassági igazolás
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                editable
                step="3"
                >
                  Vizsgadíj befizetés
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                editable
                step="4"
                >
                  Aláírt jelentkezési lap
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                    <h4>Elméleti tanfolyam</h4>
                    <br>
                    <p>Az elméleti tafolyam elvégzését követően van lehetősége kezdeményezni a KRESZ vizsgára jelentkezést.
                      <br><br>
                      <i>(Amennyiben az e-learning tanfolyamot már elvégezte, de a "Vizsgára jelentkezés" gomb nem aktív, kérjük kattintson ide: <a @click="portalGetCert()">e-learning tanfolyam adatok</a></i>)
                    </p>
                    <p>Fontos, hogy a tanfolyam kezdetétől számított <b>9 hónapon belül</b> részt kell vennie legalább egy elméleti vizsgán, illetve <b>12 hónapon</b> belül sikeresen teljesítenie kell azt!</p>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <h4>Orvosi igazolás bemutatása</h4>
                  <br>
                  <p>A tanfolyam ideje alatt az autósiskola orvosánál elkészíthető („AM” kategória esetén nem szükséges).</p>
                  <p>Amennyiben <b>már rendelkezik vezetői engedéllyel</b>, úgy az orvosi igazolás helyett a jogosítvány bemutatására lesz szükség az ügyfélszolgálaton.</p>
                  <p>A legközelebbi vizsgálat időpontjáról <a href='https://www.csigajogsi.hu/orvosi' target="_blank" class="orange--text">ITT</a> érdeklődhet!</p>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <h4>Vizsgadíj</h4>
                  <br>
                  <p>A vizsgára jelentkezés alkalmával szükséges befizetni személyesen, vagy átutalással. (Az utaláshoz szükséges díjbekérőt <a @click="getExamFees()">ITT</a> tudja igényelni.)</p>
                  <p>A vizsgadíj összege kategóriánként eltérő lehet, annak pontos mértékét a képzési szerződés tartalmazza, illetve iskolánk <a href='https://www.csigajogsi.hu' target="_blank" class="orange--text">honlapján</a> is tájékozódhat róla.</p>
                </v-stepper-content>

                <v-stepper-content step="4">
                  <h4>Hatósági jelentkezési lap</h4>
                  <br>
                  <p>A jelentkezési lap aláírására ügyfélszolgálatunkon - a vizsgára jelentkezés alkalmával - van lehetőség, vagy - amennyiben rendelkezik ügyfélkapus regisztrációval (magyarorszag.hu) - az elméleti vizsgára jelentkezéshez szükséges adatlapot <a @click="exam_app_dialog = true">online</a> is benyújthatja.</p>
                </v-stepper-content>

              </v-stepper-items>
            </v-stepper>

            <v-row justify="center">
              <v-container>
                <p>A vizsgával kapcsolatos további részleteket a képzési szerződés 1. számú mellékletében talál!</p>
              </v-container>
            </v-row>

        </div>

      <v-data-table
        v-if="!ex_res_loading && student_exam_result != ''"
        :headers="student_exam_header"
        :items="student_exam_result"
        class="elevation-1"
        :items-per-page="20"
        hide-default-footer
        hide-default-header
      >
      <template
        v-slot:header="{ props: { headers, mobile } }"
      >
        <thead v-if="!mobile">
          <tr>
            <th class="text-left">Vizsga tárgya</th>
            <th class="text-left">Vizsga időpontja</th>
            <th class="text-left">Eredmény</th>
          </tr>
        </thead>
      </template>

      </v-data-table>

  </v-container>

    <v-dialog
      v-model="exam_app_dialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          <h4>Elküldi a vizsgajelentkezési igényt?</h4>
        </v-card-title>
        <v-card-text>
          Az igény feldolgozását követően e-mailen fogunk részletes tájékoztatást küldeni Önnek a vizsgára jelentkezés folyamatáról.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="exam_app_dialog = false">Nem</v-btn>
          <v-btn color="green" outlined @click="examRegMail(), exam_app_dialog = false">Igen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="titan_dialog" persistent max-width="400">
      <v-card>
        <v-card-text class="text-center">
          <h2 v-if="titan_preloader" class="pt-4">Adatlekérés folyamatban!</h2>
          <br>
          <p v-if="titan_preloader">(Ez akár fél percet is igénybe vehet...)</p>
          <v-progress-circular
            :size="50"
            indeterminate
            color="red"
            v-if="titan_preloader"
          ></v-progress-circular>
          <h3 v-if="!titan_preloader && titan_result == 'error'">{{titan_response}}</h3>
          <div v-if="!titan_preloader && titan_result == 'success'" class="text-left">
            <h3>{{titan_nev}}</h3>
            <br>
            <p><b>Tanuló azonosító:</b> {{titan_stud_id}}</p>
            <p><b>Tanfolyam kezdete:</b> {{titan_start}}</p>
            <p><b>Tanfolyam befejezése:</b> {{titan_end}}</p>
            Amennyiben a feltüntetett adatok megfelelőek, kérjük kattintson a "Rögzítés" gombra!
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="!titan_preloader && titan_result == 'success'" color="green" outlined @click="saveTitanTanf()">Rögzítés</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="titan_dialog = false">Bezár</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-dialog
          v-model="vd_pay_dialog"
          width="500"
          persistent
        >

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Vizsgadíj befizetés
            </v-card-title>

            <v-container>
              <v-data-table
                v-model="selected_exam_fees"
                v-if="exam_fees"
                :headers="exam_fees_header"
                :items="exam_fees"
                :items-per-page="20"
                hide-default-footer
                show-select
                item-key="id"
              >
              </v-data-table>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-select
                    v-model="payment_method"
                    :items="payment_methods"
                    label="Fizetési mód"
                    outlined
                  ></v-select>
                  <p v-if="payment_method == 2" class="red--text caption">(<b>Figyelem!</b> Átutalásos fizetési mód esetén a befizetett összeg jóváírása több napot is igénybe vehet!)</p>
                </v-col>
                </v-row>
                <b>Díjbekérő összege:</b> {{sum_price}} Ft
            </v-container>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="red"
                outlined
                @click="vd_pay_dialog = false"
              >
                mégsem
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                outlined
                :disabled="!payment_method || selected_exam_fees == '' || pay_vd_loading"
                :loading="pay_vd_loading"
                @click="saveVdInvoice()"
              >
                küldés
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="pay_result_dialog"
          width="350"
        >

          <v-card>

            <v-container>
              <b>{{message_response}}</b>
              <br><br>
              A díjbekérőt megküldtük e-mailen!
            </v-container>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="pay_result_dialog = false"
              >
                bezár
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="public_url"
                color="green"
                text
                :href="public_url"
                target="_blank"
              >
                díjbekérő befizetése
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <v-snackbar v-model="response_snackbar" bottom :color="!response_success ? 'error' : ''">
      {{message_response}}
      <v-btn :color="!response_success ? '' : 'pink'" text @click="response_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
        ex_res_loading: false,
        student_exam_header: [
          { text: 'Vizsga típusa', value: 'VizsgatargyMegnevezes' },
          { text: 'Vizsga ideje', value: 'idopont' },
          { text: 'Eredmény', value: 'VizsgaEredmeny' },
        ],
        exam_fees_header: [
          { text: 'Vizsga neve', value: 'tipus_nev' },
          { text: 'Vizsga fajtája', value: 'fajta_nev' },
          { text: 'Vizsgadíj összege', value: 'osszeg' },
        ],
        student_exam_result: [],
        exam_app_dialog: false,
        response_snackbar: false,
        message_response: '',
        response_success: '',
        alert_dialog: false,
        alert_message: '',
        alert_title: '',
        valid_course: '',
        titan_dialog: false,
        titan_preloader: false,
        titan_response: '',
        titan_result: '',
        titan_stud_id: '',
        titan_start: '',
        titan_end: '',
        titan_nev: '',
        payment_methods: [
          { text: 'Bankkártya (online)', value: 17 },
          { text: 'Átutalás', value: 2 },
        ],
        payment_method: '',
        rules: {
            required: value => value != '' || 'Kötelező mező!',
        },
        vd_pay_dialog: false,
        exam_fees: [],
        selected_exam_fees: [],
        sum_price: null,
        public_url: '',
        pay_result_dialog: false,
        pay_vd_loading: false
      }
    },
    methods: {
      getExamResult: async function() {
        this.ex_res_loading = true
        await this.gettoken()
        this.$http.post('/adatok/exam_result_231007', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.ex_res_loading = false
          this.student_exam_result = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getCourseDatas: async function() {
        await this.gettoken()
        this.$http.post('/adatok/tanfolyam_exam_adatok', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          console.log(response.data);
          this.valid_course = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      portalGetCert: async function() {
        this.titan_dialog = true;
        this.titan_preloader = true;
        await this.gettoken()
        this.$http.post('/adatok/getTitanCert', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.titan_preloader = false;
          this.titan_response = response.data['message'];
          this.titan_result = response.data['result'];
          this.titan_stud_id = response.data['stud_id'];
          this.titan_start = response.data['LearningStartingDate'];
          this.titan_end = response.data['CourseCertificationDate'];
          this.titan_nev = response.data['Nev'];
          console.log(response.data);
        }, (error) => {
          this.titan_preloader = false;
          this.titan_response = "Hiba történt az adatok lekérése közben!";
          console.log(error.data);
        })
      },
      saveTitanTanf: async function() {
        await this.gettoken()
        this.$http.post('/adatok/save_stat', {
          token: this.token,
          contract_id: this.contract_id,
          titan_stud_id: this.titan_stud_id,
          titan_start: this.titan_start,
          titan_end: this.titan_end
        }).then((response) => {
            this.response_success = response.data['success'];
            this.message_response = response.data['message']
            this.response_snackbar = true
            this.titan_dialog = false;
            this.getCourseDatas();
          console.log(response.data);
        }, (error) => {
            this.response_success = false;
            this.message_response = "Hiba történt, kérjük keresse fel ügyfélszolgálatunkat!"
            this.response_snackbar = true
            this.titan_dialog = false;
          console.log(error.data);
        })
      },
      examRegMail: async function () {
        this.message_dialog = false
        await this.gettoken()
          this.$http.post('/adatok/exam_reg_mail_220113', {
            token: this.token,
            contract_id: this.contract_id
          }).then((response) => {
            this.response_success = response.data['success'];
            this.message_response = response.data['message']
            this.response_snackbar = true
            if (response.data['success'] == true) {
              this.valid_course = false;
            }
          }, (error) => {
            console.log(error.data);
          })
      },
      getAlertMessage: async function() {
        await this.gettoken()
        this.$http.post('/adatok/exam_alert', {
          token: this.token
        }).then((response) => {
          this.alert_message = response.data['message']
          this.alert_title = response.data['title']
          if (this.alert_message != null) {
            this.alert_dialog = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      getExamFees: async function () {
        this.selected_exam_fees = []
        this.exam_fees = [];
        this.payment_method = '';
        await this.gettoken()
          this.$http.post('/adatok/vizsgadijak', {
            token: this.token,
            contract_id: this.contract_id
          }).then((response) => {
            this.exam_fees = response.data;
            this.vd_pay_dialog = true;
          }, (error) => {
            console.log(error.data);
          })
      },
      saveVdInvoice: async function () {
        this.pay_vd_loading = true;
        await this.gettoken()
          this.$http.post('/outside_services/create_vd_invoice', {
            token: this.token,
            contract_id: this.contract_id,
            driving_school: this.driving_school,
            payment_method: this.payment_method,
            selected_exam_fees: this.selected_exam_fees
          }).then((response) => {
            this.pay_vd_loading = false;
            this.vd_pay_dialog = false;
            this.message_response = response.data['message'];
            if (response.data['result'] == 'error') {
              this.response_success = 'error'
              this.response_snackbar = true
            } else {
              this.public_url = response.data['public_url'];
              this.pay_result_dialog = true
            }
          }, (error) => {
            this.pay_vd_loading = false;
            console.log(error.data);
          })
      },
    },
    mounted() {
      if (this.contract_id) {
        this.getExamResult()
        this.getCourseDatas()
      }
      //this.getExamResult()
      this.getAlertMessage()
    },
    watch: {
      contract_id() {
        this.getExamResult()
        this.getCourseDatas()
      },
      selected_exam_fees(value) {
        this.sum_price = null;
        value.forEach((exam_fee) => {
          this.sum_price += parseInt(exam_fee.osszeg);
        });
      }
    },
    computed: {
    ...mapFields([
      'ids.contract_id',
      'ids.contract_driving_school',
      'ids.driving_school',
      'actions.preloader',
      'actions.message_dialog',
  ]),
  },
  }
</script>

<style lang="css">
</style>
